import React, { Component } from "react"

import { casinoList, highlightCasino, highlightCasinoAU, highlightCasinoCA, highlightCasinoUSPA, highlightCasinoUSMI, highlightCasinoUSNJ, highlightCasinoUSCO, highlightCasinoUSIN, highlightCasinoUS, casinoListAU, casinoListCA, casinoListUSNJ, casinoListUSPA, casinoListUSMI, casinoListUSCO, casinoListUSIN, casinoListUS } from "../data/casinoList"
import Affpixel from "../components/affPixel"

import Layout from "../components/layout"
import Casino from "../components/casino"
import Highlighted from "../components/highlighted"
// import SEO from "../components/seo"

import Container from "react-bootstrap/Container"

class IndexPage extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }
  componentDidMount() {
    if (typeof window !== "undefined" && window.location.search) {
      this.getParams(window.location.search.substring(1))
    }
  }

  getParams(url) {
    let paramsObj = {}
    let query = url
    let paramsArray = query.split("&")

    for (const value of paramsArray) {
      let splitParam = value.split("=")

      paramsObj[splitParam[0]] = splitParam[1] //decodeURIComponent()
    }

    this.setState({
      params: paramsObj,
    })
  }
  renderPixel(state) {
    if (state !== undefined) {
      return <Affpixel params={state} />
    } else return null
  }

  render() {
	let highlightCasinoFinal = highlightCasino
	let casinoListFinal = casinoList
	
	if (this.state.params !== undefined) {
		if (this.state.params.country === "au") {
			casinoListFinal = casinoListAU
			highlightCasinoFinal = highlightCasinoAU
		} else if (this.state.params.country  === "ca") {
			casinoListFinal = casinoListCA
			highlightCasinoFinal = highlightCasinoCA
		} else if (this.state.params.country  === "us") {
			if (this.state.params.state === "nj") {
				casinoListFinal = casinoListUSNJ
				highlightCasinoFinal = highlightCasinoUSNJ
			} else if (this.state.params.state  === "pa") {
				casinoListFinal = casinoListUSPA
				highlightCasinoFinal = highlightCasinoUSPA
			} else if (this.state.params.state  === "mi") {
				casinoListFinal = casinoListUSMI
				highlightCasinoFinal = highlightCasinoUSMI
			} else if (this.state.params.state  === "co") {
				casinoListFinal = casinoListUSCO
				highlightCasinoFinal = highlightCasinoUSCO
			} else if (this.state.params.state  === "in") {
				casinoListFinal = casinoListUSIN
				highlightCasinoFinal = highlightCasinoUSIN
			} else {
				casinoListFinal = casinoListUS
				highlightCasinoFinal = highlightCasinoUS
			}
		}
	} else {
		casinoListFinal = casinoListUS
		highlightCasinoFinal = highlightCasinoUS
	}
    const casinos = casinoListFinal.map((item, index) => {
      const {
        img,
        highlight,
        nonHighlight,
        line2,
        deposit,
        play,
        score,
        stars,
        redirect,
        alt,
      } = item
      return (
        <Casino
          key={index}
          img={img}
          high={highlight}
          nonHigh={nonHighlight}
          line2={line2}
          dep={deposit}
          play={play}
          score={score}
          stars={stars}
          redirect={redirect}
          alt={alt}
          params={this.state.params}
        />
      )
    })
    return (
      <Layout>
        <Container className="header__container">
          <h1>best offers, biggest returns, more winners!</h1>
          <p>
            <span>
              welcome to Online Casino! we offer the very best casino
              bonuses out there,{" "}
            </span>
            giving you the very best chance to win big!
          </p>
        </Container>
        <Container className="shadow__container highlight__container">
          <Highlighted casino={highlightCasinoFinal} params={this.state.params} />
        </Container>
        <Container className="shadow__container margin__top">
          {casinos}
        </Container>
        {this.renderPixel(this.state.params)}
      </Layout>
    )
  }
}

export default IndexPage
